import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';
var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
// rank
export function rankAjaxTable(limit,pagination,id,login,rank,created_at){
	const data = request({
		url: config.url+'rank_list/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&login=' + login + '&rank=' + rank + '&created_at=' + created_at,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function rankAdd(postData){
	const data = request({
		url: config.url+'rank_list/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getRankEdit(id){
	const data = request({
		url: config.url+'rank_list/edit?id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function rankEdit(postData){
	const data = request({
		url: config.url+'rank_list/edit',
		method: 'post',
		data: postData,

	});

	return Promise.resolve(data);
}

export function rankDelete(postData){
	const data = request({
		url: config.url+'rank_list/delete',
		method: 'post',
		data: postData,

	});

	return Promise.resolve(data);
}
export function rankMemberAjaxTable(limit,pagination,id,created_at,login,rank,is_system_auto){
	const data = request({
		url: config.url+'user_rank/ajaxTable?limit='+limit+'&pagination='+pagination+'&id='+id+'&created_at='+created_at+'&login='+login+'&rank='+rank+'&is_system_auto='+is_system_auto,
		method: 'get'
	});

	return Promise.resolve(data);
}